import superagent from 'superagent';
import uuidv4 from 'uuid/v4';
import * as types from './types';

import { userLogout, forbiddenAccess, checkVersionMisMatch } from './auth';

const request = superagent.agent().set('ETag', window.Config.APP_VERSION).use(function (req) {
  req.on('response', function (res) {
    if (res.status === 401) {
      console.log('UnAuthorized');
      userLogout();
    } else if (res.status === 403) {
      console.log('Forbidden');
      forbiddenAccess();
    }
  });
});

export function getOutreachStart() {
  return {
    type: types.GET_OUTREACHES_START,
  };
}

export function getOutreachSuccess(outreaches) {
  return {
    type: types.GET_OUTREACHES_SUCCESS,
    outreaches,
  };
}

export function getOutreachFail() {
  return {
    type: types.GET_OUTREACHES_FAIL,
  };
}

export function getOutreach(businessId) {
  return (dispatch, getState) => {
    dispatch(getOutreachStart());
    request
      .get(`${window.Config.API_URL}/business/outreaches`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(getOutreachSuccess(resp.body));
          dispatch(checkVersionMisMatch(resp.headers));
        } else {
          dispatch(getOutreachFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getOutreachFail());
      });
  };
}

export function saveOutreachName(name) {
  return {
    type: types.SAVE_OUTREACH_NAME,
    name,
  };
}

export function createCampaignStart() {
  return {
    type: types.CREATE_CAMPAIGN_START,
  };
}

export function createCampaignSuccess(campaign, exit) {
  return {
    type: types.CREATE_CAMPAIGN_SUCCESS,
    campaign,
    exit,
  };
}

export function createCampaignFail() {
  return {
    type: types.CREATE_CAMPAIGN_FAIL,
  };
}

export function createCampaign(params, create, props, exit, send) {
  return (dispatch, getState) => {
    dispatch(createCampaignStart());

    let param = {};
    if (create) {
      param = Object.assign(
        {},
        {
          business_id: params.business_id,
          name: params.name,
          template: params.template,
          status: 'CREATED',
        },
      );
    } else {
      param = Object.assign({}, params);
    }

    request
      .post(`${window.Config.API_URL}/business/outreach`).withCredentials().set('X-Request-ID', uuidv4())
      .send(param)
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          dispatch(createCampaignSuccess(resp.body, exit));
          if (send) {
            dispatch(postCampaign(params.business_id, send, props));
          }
          if (!send && exit) {
            props.history.goBack();
          }
          // else{props.history.push('/campaign/'+resp.body.id)}
        } else {
          dispatch(createCampaignFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(createCampaignFail());
      });
  };
}

export function getCampaignStart() {
  return {
    type: types.GET_CAMPAIGN_START,
  };
}

export function getCampaignSuccess(campaign) {
  return {
    type: types.GET_CAMPAIGN_SUCCESS,
    campaign,
  };
}

export function getCampaignFail() {
  return {
    type: types.GET_CAMPAIGN_FAIL,
  };
}

export function getCampaignOutreach(businessId, id) {
  return (dispatch, getState) => {
    dispatch(getCampaignStart());
    request
      .get(`${window.Config.API_URL}/business/outreach/${id}`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          console.log(resp);
          dispatch(getCampaignSuccess(resp.body));
          dispatch(checkVersionMisMatch(resp.headers));
        } else {
          dispatch(getCampaignFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(getCampaignFail());
      });
  };
}

export function deleteContactStart() {
  return {
    type: types.GET_CAMPAIGN_START,
  };
}

export function deleteContactSuccess(campaign, fileupload) {
  return {
    type: types.GET_CAMPAIGN_SUCCESS,
    campaign,
    fileupload,
  };
}

export function deleteContactFail() {
  return {
    type: types.GET_CAMPAIGN_FAIL,
  };
}

export function deleteContact(businessId, id, fileupload) {
  return (dispatch, getState) => {
    dispatch(deleteContactStart());
    request
      .del(`${window.Config.API_URL}/business/outreach/${id}/contacts`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          console.log(resp);
          dispatch(deleteContactSuccess(resp.body, fileupload));
        } else {
          dispatch(deleteContactFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(deleteContactFail());
      });
  };
}

export function postContactStart() {
  return {
    type: types.GET_CAMPAIGN_START,
  };
}

export function postContactSuccess(campaign, name) {
  return {
    type: types.POST_CONTACTS_SUCCESS,
    campaign,
    name,
  };
}

export function postContactFail(message) {
  return {
    type: types.POST_CONTACTS_FAIL,
    message,
  };
}

export function postContact(businessId, id, contacts, name) {
  return (dispatch, getState) => {
    dispatch(postContactStart());
    request
      .post(`${window.Config.API_URL}/business/outreach/${id}/contacts`).withCredentials().set('X-Request-ID', uuidv4())
      .send({ contacts })
      .ok((resp) => resp.status < 401)
      .then((resp) => {
        console.log('resp', resp);
        if (resp.statusCode === 200) {
          dispatch(postContactSuccess(resp.body, name));
        } else if (resp.status === 400) {
          dispatch(postContactFail(resp.body));
        }
      })
      .catch((ex) => {
        dispatch(postContactFail('please update contacts in suggested format'));
      });
  };
}
export function postCampaignStart() {
  return {
    type: types.GET_CAMPAIGN_START,
  };
}

export function postCampaignSuccess(campaign) {
  return {
    type: types.GET_CAMPAIGN_SUCCESS,
    campaign,
  };
}

export function postCampaignFail(apierror, errormessage) {
  let message = { apierror: true, message: apierror ? errormessage : '' };
  console.log('apierror', apierror);
  return {
    type: types.SEND_CAMPAIGN_FAIL,
    message,
  };
}

export function postCampaign(businessId, id, props) {
  return (dispatch, getState) => {
    dispatch(postCampaignStart());
    request
      .post(`${window.Config.API_URL}/business/outreach/${id}/send`).withCredentials().set('X-Request-ID', uuidv4())
      .ok((res) => res.status < 504)
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          console.log(resp);
          dispatch(postCampaignSuccess(resp.body));
          props.history.goBack();
        } else {
          dispatch(postCampaignFail(true, resp.body));
        }
      })
      .catch((error) => {
        dispatch(postCampaignFail(false));
      });
  };
}

export function deleteOutreachStart() {
  return {
    type: types.DEL_CAMPAIGN_START,
  };
}

export function deleteOutreachSuccess(campaign) {
  return {
    type: types.DEL_CAMPAIGN_SUCCESS,
    campaign,
  };
}

export function deleteOutreachFail() {
  return {
    type: types.DEL_CAMPAIGN_FAIL,
  };
}

export function deleteOutreach(businessId, id) {
  return (dispatch, getState) => {
    dispatch(deleteOutreachStart());
    request
      .delete(`${window.Config.API_URL}/business/outreach/${id}`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          resp.body.id = id;
          dispatch(deleteOutreachSuccess(resp.body));
        } else {
          dispatch(deleteOutreachFail());
        }
      })
      .catch((ex) => {
        console.log(ex);
        dispatch(deleteOutreachFail());
      });
  };
}

export function closeFileModal() {
  return (dispatch, getState) => {
    dispatch({
      type: types.FILE_MODAL_CLOSE,
    });
  };
}

export function refreshSuccess(campaign) {
  return {
    type: types.REFRESH_CAMPAIGN,
    campaign,
  };
}
export function refreshCampaign(businessId, id) {
  return (dispatch, getState) => {
    request
      .get(`${window.Config.API_URL}/business/outreach/${id}`).withCredentials().set('X-Request-ID', uuidv4())
      .then((resp) => {
        console.log(resp);
        if (resp.statusCode === 200) {
          console.log(resp);
          dispatch(refreshSuccess(resp.body));
        }
      })
      .catch((ex) => { });
  };
}
